import type { Lote } from '../types/lote'

// Plano de lotificación Hacienda El Rodeo — 40 lotes (8 filas x 5 columnas)
export const lotes: Lote[] = [
  { numero: 1, medidas: '15m x 20m', area: 300, precio: 35000, estado: 'vendido' },
  { numero: 2, medidas: '15m x 20m', area: 300, precio: 36500, estado: 'vendido' },
  { numero: 3, medidas: '15m x 22m', area: 330, precio: 39000, estado: 'disponible' },
  { numero: 4, medidas: '15m x 22m', area: 330, precio: 39500, estado: 'vendido' },
  { numero: 5, medidas: '18m x 22m', area: 396, precio: 45000, estado: 'apartado' },
  { numero: 6, medidas: '15m x 20m', area: 300, precio: 36000, estado: 'vendido' },
  { numero: 7, medidas: '15m x 20m', area: 300, precio: 37000, estado: 'vendido' },
  { numero: 8, medidas: '15m x 22m', area: 330, precio: 40000, estado: 'vendido' },
  { numero: 9, medidas: '15m x 22m', area: 330, precio: 41000, estado: 'disponible' },
  { numero: 10, medidas: '18m x 22m', area: 396, precio: 46500, estado: 'vendido' },
  { numero: 11, medidas: '15m x 20m', area: 300, precio: 37500, estado: 'vendido' },
  { numero: 12, medidas: '15m x 20m', area: 300, precio: 38000, estado: 'apartado' },
  { numero: 13, medidas: '16m x 22m', area: 352, precio: 42000, estado: 'vendido' },
  { numero: 14, medidas: '16m x 22m', area: 352, precio: 42500, estado: 'vendido' },
  { numero: 15, medidas: '18m x 24m', area: 432, precio: 49000, estado: 'disponible' },
  { numero: 16, medidas: '15m x 20m', area: 300, precio: 38500, estado: 'vendido' },
  { numero: 17, medidas: '15m x 21m', area: 315, precio: 39500, estado: 'vendido' },
  { numero: 18, medidas: '16m x 22m', area: 352, precio: 43000, estado: 'vendido' },
  { numero: 19, medidas: '16m x 24m', area: 384, precio: 46000, estado: 'disponible' },
  { numero: 20, medidas: '18m x 24m', area: 432, precio: 51000, estado: 'vendido' },
  { numero: 21, medidas: '15m x 21m', area: 315, precio: 40000, estado: 'vendido' },
  { numero: 22, medidas: '15m x 21m', area: 315, precio: 40500, estado: 'vendido' },
  { numero: 23, medidas: '16m x 24m', area: 384, precio: 47000, estado: 'apartado' },
  { numero: 24, medidas: '16m x 24m', area: 384, precio: 47500, estado: 'vendido' },
  { numero: 25, medidas: '20m x 24m', area: 480, precio: 56000, estado: 'disponible' },
  { numero: 26, medidas: '15m x 22m', area: 330, precio: 42000, estado: 'vendido' },
  { numero: 27, medidas: '15m x 22m', area: 330, precio: 42500, estado: 'vendido' },
  { numero: 28, medidas: '18m x 24m', area: 432, precio: 52000, estado: 'disponible' },
  { numero: 29, medidas: '18m x 24m', area: 432, precio: 52500, estado: 'vendido' },
  { numero: 30, medidas: '20m x 25m', area: 500, precio: 58000, estado: 'vendido' },
  { numero: 31, medidas: '16m x 22m', area: 352, precio: 44000, estado: 'vendido' },
  { numero: 32, medidas: '16m x 22m', area: 352, precio: 44500, estado: 'disponible' },
  { numero: 33, medidas: '18m x 26m', area: 468, precio: 55000, estado: 'vendido' },
  { numero: 34, medidas: '18m x 26m', area: 468, precio: 55500, estado: 'vendido' },
  { numero: 35, medidas: '22m x 26m', area: 572, precio: 64000, estado: 'disponible' },
  { numero: 36, medidas: '16m x 24m', area: 384, precio: 48000, estado: 'vendido' },
  { numero: 37, medidas: '16m x 24m', area: 384, precio: 48500, estado: 'disponible' },
  { numero: 38, medidas: '20m x 26m', area: 520, precio: 60000, estado: 'vendido' },
  { numero: 39, medidas: '22m x 28m', area: 616, precio: 68000, estado: 'disponible' },
  { numero: 40, medidas: '25m x 30m', area: 750, precio: 75000, estado: 'disponible' },
]
